import { useEffect } from 'react';
import { Location, useLocation } from 'react-router-dom';

export type LocationListenerCallback = (location: Location) => void;

export function useLocationListener(callback: LocationListenerCallback) {
    const location = useLocation();

    useEffect(() => {
        callback(location);
    }, [ location, callback ]);
}
